import "./CompanyCodeInfo.css";

const CompanyCodeInfo = ({ data }) => {
	return (
		<div className="CompanyCodeInfo">
			<div className="InnKppModalDataRowWithCell">
				<span className="InnKppModalDataCell">ОКАТО: {data.okato}</span>
				<span className="InnKppModalDataCell">ОКПО: {data.okpo}</span>
				<span className="InnKppModalDataCell">ОКТМО: {data.oktmo}</span>
				<span className="InnKppModalDataCell">ОКОГУ: {data.okogu}</span>
				<span className="InnKppModalDataCell">ОКФС: {data.okfs}</span>
			</div>
			<div className="InnKppModalDataRow">
				ОКВЭД:{" "}
				<span>
					{data.okved && data.okved} {data.okved_name && `(${data.okved_name})`}{" "}
				</span>
			</div>
		</div>
	);
};

export default CompanyCodeInfo;
